import { type GetStaticProps } from 'next'
import {
  ShowroomPage,
  prepareGetStaticPropsForShowroomPage,
} from '@public/CmsPage/ShowroomPage'
import { ROUTE } from 'constants/routes'

const SLUG = 'shop/brands'

export const getStaticProps: GetStaticProps = (context) =>
  prepareGetStaticPropsForShowroomPage(context, {
    slug: SLUG,
    route: ROUTE.SHOWROOM_BRANDS(),
  })

export default ShowroomPage
